"use client";

import ReactCountryFlag from "react-country-flag";
import { useLocale, useSetLocale } from "../hooks/locale-provider";
import { cn } from "@sajilni/utils/cn";
import { useTransition } from "react";
import { useTranslation } from "@sajilni/localization";

export interface LanguagesPreviewProps {
  languages: {
    code: string;
    flagCode: string;
    name: string;
    id: string;
  }[];
  switchLocaleAction?: (code: string) => void; // ✅ optional
}

export const LanguagesPreview = ({
  languages,
  switchLocaleAction,
}: LanguagesPreviewProps) => {
  const { t } = useTranslation("sajilni2.0");
  const locale = useLocale();
  const setLocale = useSetLocale();
  const [isPending, startTransition] = useTransition();

  return (
    <div className="flex  flex-wrap gap-1">
      {languages.map((lang) => {
        const isActive = locale === lang.code;

        const handleClick = () => {
          if (switchLocaleAction && !isActive) {
            setLocale(lang.code as any);
            startTransition(() => switchLocaleAction(lang.code));
          }
        };

        return (
          <div
            key={lang.id}
            onClick={handleClick}
            className={cn(
              "flex h-6 w-fit items-center gap-1 rounded-full border px-2 py-1",
              isActive
                ? "border-[#ABEFC6] bg-[#ECFDF3] text-[#067647]"
                : "border-gray-200 bg-white text-gray-800",
              switchLocaleAction && !isActive
                ? "cursor-pointer hover:bg-gray-100"
                : ""
            )}
          >
            <ReactCountryFlag
              countryCode={lang.flagCode}
              svg
              style={{ width: "16px", height: "16px" }}
              title={lang.name}
            />
            <span className="text-xs font-medium">{t(`${lang.name}`)}</span>
          </div>
        );
      })}
    </div>
  );
};
